import { render, staticRenderFns } from "./staticTable.vue?vue&type=template&id=47b8a64e&scoped=true"
import script from "./staticTable.vue?vue&type=script&lang=js"
export * from "./staticTable.vue?vue&type=script&lang=js"
import style0 from "./staticTable.vue?vue&type=style&index=0&id=47b8a64e&lang=css"
import style1 from "./staticTable.vue?vue&type=style&index=1&id=47b8a64e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b8a64e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47b8a64e')) {
      api.createRecord('47b8a64e', component.options)
    } else {
      api.reload('47b8a64e', component.options)
    }
    module.hot.accept("./staticTable.vue?vue&type=template&id=47b8a64e&scoped=true", function () {
      api.rerender('47b8a64e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/staticTable.vue"
export default component.exports